<script lang="ts">
  import Display from "../../organisms/settings/Display.svelte";
</script>

<div class="flex">
  <div class="flex-1 mr-8">
    <Display />
  </div>
</div>
